import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { useEffect } from "react"
import { PageLoading } from "~/components/PageLoading"
import AppLayout from "~/layouts/AppLayout"
import { api } from "~/utils/api"
import { EVideoEditorDestination, videoEditorDestination } from "~/utils/videoEditorRoute"

const VidmaxVideoPage = () => {
  const { videoId } = Route.useParams()
  const navigate = useNavigate()
  const { data: video, isLoading } = api.video.getVideoById.useQuery({ id: videoId })

  useEffect(() => {
    if (!video) return

    switch (videoEditorDestination(video)) {
      case EVideoEditorDestination.TRACK_EDITOR:
        void navigate({ to: "/create/edit", search: { videoId } })
        break
      case EVideoEditorDestination.FAKE_TEXT:
        void navigate({ to: `/videos/${videoId}/editor/fake-text` })
        break
      case EVideoEditorDestination.REDDIT_STORY:
        void navigate({ to: `/videos/${videoId}/editor/reddit-story` })
        break
      case EVideoEditorDestination.GENZ_AVATARS:
        void navigate({ to: `/videos/${videoId}/editor/genz-avatars` })
        break
      case EVideoEditorDestination.STORYBOARD:
        void navigate({ to: `/videos/${videoId}/storyboard` })
        break
      case EVideoEditorDestination.VIDEO_STUDIO:
        void navigate({ to: `/videos/${videoId}/editor` })
        break
    }
  }, [isLoading, navigate, videoId, video])

  if (isLoading) {
    return <PageLoading />
  }

  if (!video) {
    return <div>Video not found</div>
  }

  return <PageLoading />
}

function VidmaxVideoPageWrapper() {
  return (
    <AppLayout>
      <VidmaxVideoPage />
    </AppLayout>
  )
}

export const Route = createFileRoute("/videos/$videoId/")({
  component: VidmaxVideoPageWrapper,
})
